import type { PropsWithChildren } from "react";
import { useMemo } from "react";
import { checkAccess } from "../utilities/accessHelper.ts";
import type { ReportAccessType } from "../api/reportAccessTypes.ts";
import type { AccessPermission } from "../api/types";
import { useClientPermissionsContext } from "../contexts/ClientPermissionsContext";

interface Props {
  permissions: AccessPermission[];
  access?: ReportAccessType;
  requiredAccess?: ReportAccessType;
  clientCode?: string;
}

const ReportAuthorizedBox = ({
  clientCode,
  permissions,
  requiredAccess,
  access,
  children,
}: PropsWithChildren<Props>) => {
  const { hasAnyPermission, hasAnyPermissionForClient } = useClientPermissionsContext();

  const hasPermissions = useMemo(() => {
    if (clientCode) {
      return hasAnyPermissionForClient(clientCode, permissions);
    }
    return hasAnyPermission(permissions);
  }, [clientCode, hasAnyPermission, hasAnyPermissionForClient, permissions]);

  const hasAccessType = useMemo(() => {
    if (requiredAccess === undefined || access === undefined) {
      return true;
    }
    return checkAccess(access, requiredAccess);
  }, [access, requiredAccess]);

  if (!hasPermissions || !hasAccessType) return null;

  return <>{children}</>;
};

export default ReportAuthorizedBox;
